<template>
<el-card class="box-card" shadow="hover">
  <div slot="header" class="clearfix" style="position:relative">
    <el-breadcrumb>
      <el-breadcrumb-item>po单管理</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="text item">
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="生成时间">
        <el-date-picker
          v-model="sreachData.createTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="请选择开始时间"
          end-placeholder="请选择结束时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setWeek">最近一周</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setMonth">最近一个月</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" plain @click="setThreeMonth">最近三个月</el-button>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="需求来源" v-if="showBtn==3||showBtn<1||showBtn==2">
        <el-select v-model="sreachData.company" filterable clearable placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(val, key) in company" :key="key" :label="val.company" :value="val.id">{{val.company}}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="供应商" v-if="showBtn==3||showBtn<1||showBtn==5">
        <el-select v-model="sreachData.supplier" filterable clearable placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(val, key) in supplier" :key="key" :label="val.company" :value="val.companyid">{{val.company}}</el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" inline label-width="140px">
      <el-form-item label="关键词">
        <el-input v-model="sreachData.words" placeholder="订单号|编码|名称|描述/规格|单位|备注" style="width:300px;">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="searchOrder">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      tooltip-effect="dark"
      :data="tableData"
      style="width: 100%"
      row-key="id"
      border>
      <el-table-column
        prop="id"
        width="50"
        label="ID">
      </el-table-column>
      <el-table-column
        prop="sn"
        label="po单号">
      </el-table-column>
      <el-table-column
        prop="company"
        label="需求方">
      </el-table-column>
      <el-table-column
        prop="supplier"
        label="供应商">
      </el-table-column>
      <el-table-column
        prop="createTime"
        width="140"
        label="创建时间">
      </el-table-column>
      <el-table-column
        label="操作"
        width="220">
        <template slot-scope="scope">
          <el-button size="mini" type="info" plain @click="downfile(scope.row.pofile)">下载文件</el-button>
          <el-popconfirm
            confirm-button-text='好的'
            cancel-button-text='不用了'
            icon="el-icon-info"
            icon-color="red"
            @confirm="delPOOrders(scope.row.id)" 
            title="确定删除po单吗？"
          >
            <el-button v-if="showBtn==0" size="mini" type="danger" plain slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <p>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="sreachData.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="sreachData.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </p>
  </div>
</el-card>
</template>
<script>
import userFunction from "@/api/user"
import orderFunction from "@/api/order"
export default {
  data() {
    return {
      showBtn:sessionStorage.getItem('roleid'),
      total:0,
      tableLoading:false,
      activeName:"",
      level:[],
      Selectionids:[],
      log:[],
      supplier:[],
      company:[],
      expressNum:0,
      sreachData:{
        createTime:[],
        num:'',
        limit:10,
        page:1,
        supplier:'',
        minMoney:'',
        maxMoney:'',
        company:'',
        status:'',
        words:'',
        vcode:sessionStorage.getItem('token'),
      },
      tableData:[],
      sendForm:{
        id:'',
        sendType:0,
        expressCompany:'',
        expressNum:0,
        expressSn:'',
        expressRemark:'',
        vcode:sessionStorage.getItem('token'),
      },
      serviceForm:{
        id:'',
        type:1,
        noNum:0,
        num:0,
        reviceNum:0,
        name:'',
        phone:'',
        remark:'',
        vcode:sessionStorage.getItem('token')
      },
      form:{
        gcode:'',
        cgcode:'',
        title:'',
        unit:'',
        price:'',
        remark:'',
        deliveryTime:'',
        factory:'',
        purchase:'',
        locator:'',
        num:'',
        orderRemark:'',
        examine:0,
        examineMsg:'',
        vcode:sessionStorage.getItem('token'),
      }
    }
  },
  methods:{
    setWeek(){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      this.sreachData.createTime = [start,end]
    },
    setMonth(){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.sreachData.createTime = [start,end]
    },
    setThreeMonth(){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      this.sreachData.createTime = [start,end]
    },
    handleSizeChange(val){
      this.sreachData.limit = val
      this.getList()
    },
    handleCurrentChange(val){
      this.sreachData.page = val
      this.getList()
    },
    getList(){
      orderFunction.polist(this.sreachData,this).then(res=>{
        this.tableData = res.data
        this.total = res.total
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    downfile(file){
      let a = document.createElement('a')
        a.href = file
        a.click()
    },
    searchOrder(){
      this.tableData = []
      this.getList()
    },
    exportOrder(){
      orderFunction.exportOrder(this.sreachData,this).then(res=>{
        let a = document.createElement('a')
        a.href = res.filepath
        a.click()
      })
    },
    getCompany(){
      userFunction.getCompany({vcode:sessionStorage.getItem('token')},this).then((res) => {
        this.company = res
      })
    },
    getSupplier(){
      userFunction.getSupplier({vcode:sessionStorage.getItem('token')},this).then((res) => {
        this.supplier = res
      })
    },
    delPOOrders(id){
      orderFunction.delPOOrders({id:id,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.getList()
      }).catch(err=>{
        this.$message.error(err)
      })
    }
  },
  mounted () {
    this.getList()
    if(this.showBtn<1||this.showBtn==3||this.showBtn==5){
      this.getSupplier()
    }
    if(this.showBtn<1||this.showBtn==3||this.showBtn==2){
      this.getCompany()
    }
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/order/polist.vue